<div class="container mobile-container container-space">
  <div [ngClass]="{'d-none': !isMobile || !router.url.endsWith(RouteUtil.ACCOUNT_COMPONENT)}"
       class="d-flex align-items-center justify-content-between">
    <div class="Title-box d-flex flex-column align-items-center justify-content-start">
      <span>{{ 'UserAccount' | translate }}</span>
      <img class="mt-2 d-lg-block d-none"
           src="/icons/line-categories.svg">
    </div>
    <div class="btn-back">
      <span (click)="openBackClicked()">
        {{ 'BackToMenu' | translate }}
        <img src="/icons/forward-outline.svg">
      </span>
    </div>
  </div>
</div>
<div class="d-grid w-100 grid-box"
     style="max-width: 1335px;">
  <div [ngClass]="{'d-none': isMobile && !router.url.endsWith(RouteUtil.ACCOUNT_COMPONENT)}"
       class="panel border-0">
    <div (click)="changeTab(0)"
         [class.changeFormat]="activeTab === 0"
         class="col-12 btn-account d-flex align-items-center justify-content-between">
        <span>
          <img src="/icons/person.svg">
          {{ 'IndividualProfile' | translate }}
        </span>
      <img class="arrow-icon"
           src="/icons/chevron-right.svg">
    </div>
    <hr>
    <div (click)="changeTab(2)"
         [class.changeFormat]="activeTab === 2"
         class="col-12 btn-account d-flex align-items-center justify-content-between">
        <span>
          <img src="/icons/heart.svg">
          {{ 'Favorites' | translate }}
        </span>
      <img class="arrow-icon"
           src="/icons/chevron-right.svg">
    </div>
    <hr>
    <div (click)="changeTab(3)"
         [class.changeFormat]="activeTab === 3"
         class="col-12 btn-account d-flex align-items-center justify-content-between">
        <span>
          <img src="/icons/address.svg">
          {{ 'Addresses' | translate }}
        </span>
      <img class="arrow-icon"
           src="/icons/chevron-right.svg">
    </div>
    <hr>
    @if (Config.userInformation?.UserType === 'STAFF') {
      <div (click)="changeTab(4)"
           [class.changeFormat]="activeTab === 3"
           class="col-12 btn-account d-flex align-items-center justify-content-between">
        <span>
          <img src="/icons/info-circle-solid.svg">
          {{ 'AdminPanel' | translate }}
        </span>
        <img class="arrow-icon"
             src="/icons/chevron-right.svg">
      </div>
      <hr>
    }
    <div (click)="onSignOutClicked()"
         class="col-12 btn-account d-flex align-items-center justify-content-between">
        <span>
          <img src="/icons/logout.svg">
          {{ 'SignOutOfTheUserAccount' | translate }}
        </span>
    </div>
  </div>
  <div class="p-0 d-block">
    @if (!isMobile && router.url.endsWith(RouteUtil.ACCOUNT_COMPONENT)) {
      <app-profile></app-profile>
    }
    <router-outlet></router-outlet>
  </div>
</div>
